import { render, staticRenderFns } from "./ImportCohortsPage.vue?vue&type=template&id=08a16748"
import script from "./ImportCohortsPage.vue?vue&type=script&lang=js"
export * from "./ImportCohortsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports